export const DoctorRanks: Array<{
    threshold: number;
    name: string;
}> = [
    {
        threshold: 0,
        name: "Pre-Med Student",
    },
    {
        threshold: 1000,
        name: "Med Student",
    },
    {
        threshold: 2500,
        name: "Intern",
    },
    {
        threshold: 5000,
        name: "Junior Resident",
    },
    {
        threshold: 8500,
        name: "Resident",
    },
    {
        threshold: 14000,
        name: "Senior Resident",
    },
    {
        threshold: 20000,
        name: "Co-Chief Resident",
    },
    {
        threshold: 20500,
        name: "Chief Resident",
    },
    {
        threshold: 30000,
        name: "Fellow",
    },
    {
        threshold: 50000,
        name: "Attending",
    },
    {
        threshold: 85000,
        name: "Head of Diagnostics",
    },
    {
        threshold: 150000,
        name: "Chief of Medicine",
    },
];